


















import { Component, Vue, Prop } from 'vue-property-decorator'
import { Icon, Card } from '@alpha/ink'

import icoLookup from '@/utilities/ico-lookup'

import * as ui from '@/types/frontend'
@Component({
  components: {
    Icon,
    Card
  }
})
export default class InsightCard extends Vue {
  @Prop({ required: true }) activeInsightIndex!: number
  @Prop({ required: true }) insight!: ui.DynamicAsset

  get icon () {
    return icoLookup[this.insight.asset_type]
  }

  get img () {
    if (!this.insight.img) return
    if (this.insight.img.startsWith('https://static.alphahq.com/img/asset_icons/')) {
      // Replacce with new icons
      return icoLookup[this.insight.asset_type]
    } else {
      return this.insight.img
    }
  }
}
